import { useToast } from '@chakra-ui/react';
import { getItems } from 'api';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AnswersState } from 'schemas/answerStateSchema';
import { AnswersSelector, StepParamsSelector } from 'store/selectors';
import { notifySentry } from 'utils/error/notifySentry';
import defaultItemsJson from '_mock/getItems.mock.json';

export type ApiItemsType = typeof defaultItemsJson;

// to ease non hook methods, we store the items here.
// TODO: fix this.. if we are using this method outside a page with api items, it will not work. It's kind of not a good practice. We should store this inside a zustand store or something like that.
let storedItems: ApiItemsType;
export const getApiItems = () => storedItems;

export const useApiItems = () => {
  const [apiItems, setApiItems] = useState<ApiItemsType | undefined>(undefined);
  const [error, setError] = useState<Error | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const answers = useSelector(AnswersSelector) as AnswersState;
  const toast = useToast();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const country = answers.addressDetails?.countryCode;
  const postalCode = answers.addressDetails?.postCode;
  const vendor = undefined;
  const { flowType } = useSelector(StepParamsSelector);

  useEffect(() => {
    const getAllItems = async () => {
      setError(undefined);
      setIsLoading(true);
      try {
        if (country && postalCode) {
          const items = await getItems({
            country,
            postalCode,
            vendor,
            isB2B: flowType === 'b2b',
          });
          // console.log(items.data);
          storedItems = items.data;
          setApiItems(items.data);
          setIsLoading(false);
        }
      } catch (e) {
        setError(e);
        notifySentry(e);
      }
    };
    getAllItems();
  }, [
    answers.flowChoice,
    country,
    postalCode,
    vendor,
    toast,
    t,
    navigate,
    flowType,
  ]);

  return {
    items: apiItems,
    isLoading,
    error,
  };
};
